import React, { Component } from "react";
import { getCDNUrl } from "../commons/CommonFunctions";
import * as _ from "lodash";
import UnauthBanner from "./UnauthBanner";
import UnAuthProjectActivity from "./UnAuthProjectActivity";
import UnAuthRightPanel from "./UnAuthRightPanel";

export default class ProjectFeeds extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <div className="col-md-9">
        <div className="projectinn nothidden projdetailscont">
          <UnauthBanner projectDetail={this.props.projectDetail} />
          <div className="projtopbar">
            <div className="projtopbarleft">
              <div className="mcustHorizMenu">
                <div className="mcustHorizinn">
                  <ul id="tabs" className="nav">
                    <li className="nav-item">
                      <a href="javascript:void(0)" className="active">
                        Feeds
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="projdetlswrap">
            <div className="row">
              <div className="col-lg-9">
                <div className="projdtlsfeedsinn">
                  {this.props.projectDetail && (
                    <UnAuthProjectActivity project={this.props.projectDetail} />
                  )}
                </div>
              </div>
              <UnAuthRightPanel projectDetail={this.props.projectDetail} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
